module.exports = "/static/assets/0d251e7bd27c0ef2e6abbdd2c32c4b6b.png";